module.exports = __webpack_public_path__ + "img/chevronLeft.2d14218d.svg";